import { AxiosPromise } from 'axios';

import { vaultApi } from '../api';
import { IApiResponse } from '../interfaces';
import { IImpersonationStartRequest, IImpersonationStartResponse } from './interfaces';

const basePath = '/impersonation';

/* eslint-disable implicit-arrow-linebreak */

export const startImpersonation = (params: IImpersonationStartRequest): AxiosPromise<IApiResponse<IImpersonationStartResponse>> =>
  vaultApi.getInstance().post(`${basePath}/start`, params);

export const endImpersonation = (): AxiosPromise<void> =>
  vaultApi.getInstance().post(`${basePath}/end`);
